import React from 'react'
import styled from 'styled-components'

const Indicator = styled.line`
  stroke: #ccc;
  stroke-width: 2px;
`

const HoverIndicator = ({ hoverDate, xScale, yScale, minValue, maxValue }) =>
  hoverDate ? (
    <Indicator
      x1={xScale(hoverDate)}
      y1={yScale(maxValue)}
      x2={xScale(hoverDate)}
      y2={yScale(minValue)}
    />
  ) : null

export default HoverIndicator
